// extracted by mini-css-extract-plugin
module.exports = {"smallText":"tablePayments_smallText__Xlnb3","variantText":"tablePayments_variantText__6uAYX"};